import get from 'lodash/get';
import { take, takeEvery, put, select } from 'redux-saga/effects';
import { consts as moderatorsList } from './moderatorsList';
import { consts as communityModerators } from './communityModerators';
import { moderatorsListLengthSelector } from './selectors/selectors';

function* getModeratorsListWorker(action) {
  // Dispatch clear action
  if (action.type === communityModerators.CLEAR_MODERATORS) {
    yield put({
      type: moderatorsList.CLEAR,
    });
    return;
  }

  const MODERATORS_PER_PAGE = 20;
  const state = yield select();
  const communityId = +get(action.payload, 'communityId');

  const limit = MODERATORS_PER_PAGE;
  let offset = 0;
  let responseAction = moderatorsList.LOAD_MODERATORS;

  if (action.type === communityModerators.GET_OLDER_MODERATORS) {
    offset = moderatorsListLengthSelector(state);
    responseAction = moderatorsList.LOAD_OLDER_MODERATORS;
  }

  // Dispatch request
  yield put({
    type: communityModerators.SEND,
    payload: { communityId, limit, offset },
  });

  // Process response
  const response = yield take(communityModerators.SUCCEED);

  // Dispatch response
  yield put({
    type: responseAction,
    payload: response.payload,
  });
}

export function* getModeratorsListSaga() {
  yield takeEvery(
    [
      communityModerators.GET_MODERATORS,
      communityModerators.GET_OLDER_MODERATORS,
      communityModerators.CLEAR_MODERATORS,
    ],
    getModeratorsListWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/moderatorsListSaga.js